import {
  cookie,
  constants,
  isAuthenticated,
  JWTDecode
} from '@pmi/pmi-iqos-shared-react'

const IndexNameTypes = {
  PRODUCTS: constants.ALGOLIA_PRODUCTS_INDEX,
  ARTICLES: constants.ALGOLIA_ARTICLES_INDEX,
  QUERY_SUGGESTIONS: constants.ALGOLIA_QUERY_SUGGESTIONS_INDEX
}

const IndexIdTypes = {
  PRODUCTS_DEVICES: 'products_devices_accessories',
  PRODUCTS_CONSUMABLES: 'products_consumables',
  ARTICLES_SUPPORT: 'articles_support',
  ARTICLES_FAQ: 'articles_faq',
  ARTICLES_NEWS: 'articles_news',
  RECENT_SEARCHES: 'recent_searches'
}

const DisplayTypes = {
  PRODUCTS: 'products',
  ARTICLES_IMAGE: 'articles_image',
  ARTICLES_SIMPLIFIED: 'articles_simplified'
}

const RECOMMENDED_CONTENT_ID = 'recommended_content'
const INITIAL_QUERY_SUGGESTIONS_ID = 'query_suggestions_section'

const setScrolls = (id, selector) => {
  const container = document.querySelector(
    id ? `section[data-autocomplete-source-id="${id}"] ul` : selector
  )

  if (!container || container.classList.contains('scrolled')) return

  container.classList.add('scrolled')

  let isDown = false
  let isDragging = false
  let startX, scrollLeft

  container.addEventListener('mousedown', e => {
    isDown = true
    isDragging = false
    startX = e.pageX - container.offsetLeft
    scrollLeft = container.scrollLeft
    document.body.style.userSelect = 'none'
  })

  container.addEventListener('mouseleave', () => {
    isDown = false
  })

  container.addEventListener('mouseup', e => {
    isDown = false
    document.body.style.userSelect = ''
  })

  container.addEventListener('mousemove', e => {
    if (!isDown) return
    e.preventDefault()
    const x = e.pageX - container.offsetLeft
    const walkX = x - startX
    container.scrollLeft = scrollLeft - walkX
    if (Math.abs(walkX) > 5) {
      isDragging = true
    }
  })
  container.addEventListener(
    'click',
    e => {
      if (isDragging) {
        e.stopPropagation()
        e.preventDefault()
      }
    },
    true
  )
  container.addEventListener('dragstart', e => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault()
    }
  })
}

const mapResultsToTabsItems = (tabsItems, scopedResults) => {
  let newSelectedTabItemIndex = 0
  let maxNbHits = 0
  const resultTabsItems = tabsItems.map((tab, index) => {
    const nbHits = scopedResults[index]?.results?.nbHits || 0 // Number of results
    const currentPageNb = scopedResults[index]?.results?.page + 1
    if (maxNbHits < nbHits) {
      maxNbHits = nbHits
      newSelectedTabItemIndex = index
    }
    return {
      ...tab,
      nbHits,
      currentPageNb
    }
  })
  // If PRODUCTS_DEVICES has results is the default tab, otherwise is the highest one
  if (resultTabsItems && resultTabsItems[0]?.nbHits) {
    newSelectedTabItemIndex = 0
  }
  return {
    resultTabsItems,
    newSelectedTabItemIndex
  }
}

const isAV = () => {
  if (isAuthenticated()) {
    const tokenValue = cookie.getToken()
    const decodedToken = JWTDecode(tokenValue)
    return decodedToken && decodedToken.isAV
  }
  return false
}

const getSpiceIdHash = async (str, size = 16) => {
  if (!str) return ''
  const encoder = new TextEncoder()
  const data = encoder.encode(str)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
  return hashHex.slice(0, size)
}

export {
  DisplayTypes,
  IndexNameTypes,
  IndexIdTypes,
  RECOMMENDED_CONTENT_ID,
  INITIAL_QUERY_SUGGESTIONS_ID,
  isAV,
  setScrolls,
  mapResultsToTabsItems,
  getSpiceIdHash
}
